import { BaseDataService } from "../../../services/base/BaseDataService";
import { Project } from "../models/Project";
import { ProjectQuery } from "../models/ProjectQuery";

export class ProjectService extends BaseDataService<Project,ProjectQuery> {
  protected prefixUrl: string = `Projects`;
}
